
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite/[code]",
      function () {
        return require("private-next-pages/invite/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite/[code]"])
      });
    }
  